<template>
  <div>
    <identity-verification-form
      :form-model="formModel"
      :person-title="local.bankruptcy.common.theDebtor"
      :view-mode="loading"
      :manager-social-id-required="false"
      :request-owner-type-id="requestOwnerTypeId"
      :is-edit-mode="isEditMode"
      :main-request-details-types="mainRequestDetailsTypesEnum.bankruptDebts"
    ></identity-verification-form>
    <naj-dynamic-form
      :form-model="formModel"
      :form-fields="formFields"
      :view-mode="loading"
      @externalEffectEvent="externalEffectEventHandler"
    ></naj-dynamic-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('BankruptcyModule');
import IdentityVerificationForm from '../../../identity-verification-form.vue';
import { mainRequestDetailsTypesEnum, partyTypeEnum } from '@/modules/bankruptcy/helpers/enum';

export default {
  inject: ['$validator'],
  components: { IdentityVerificationForm },
  props: {
    formModel: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    requestOwnerTypeId: {
      type: Number,
      required: false,
      default: null,
    },
    isEditMode: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data() {
    return {
      locale: this.local.bankruptcy.requestDetails,
      mainRequestDetailsTypesEnum,
      partyTypeEnum,
    };
  },
  computed: {
    ...mapState(['countries', 'countryCities', 'yesNoOptions']),
    cities() {
      return this.countryCities[this.formModel.countryId];
    },
    isGovernmentOrForeignCompany(){
      var validTypes = [partyTypeEnum.government, partyTypeEnum.foreignCompany];
      return validTypes.indexOf(this.formModel.typeId) !== -1;
    },
    validatingEmail(){
      if(this.formModel.typeId != partyTypeEnum.government)
      {
        return {
                email: true,
                no_gov_email: true,
              }
      }
      else 
      { return {
                email: true,
              }
      }
    },
    formFields() {
      return [
        {
          typeId: this.formFieldType.text,
          name: 'mobile',
          label: this.locale.bankruptDueRights.mobile,
          columnSize: 6,
          properties: JSON.stringify({
            validations: {
              numeric: true,
              phone: true,
              digits: 10,
              },
              if: `${!this.isGovernmentOrForeignCompany}`,
          }),
        },
        {
          typeId: this.formFieldType.text,
          name: 'email',
          label: this.locale.bankruptDueRights.email,
          columnSize: 6,
          properties: JSON.stringify({
            validations: this.validatingEmail,
          }),
        },
        {
          typeId: this.formFieldType.text,
          name: 'debtValue',
          label: this.locale.bankruptDueRights.debtValue,
          columnSize: 6,
          properties: JSON.stringify({
            validations: {
              required: true,
              decimal: 2,
              min_value: '0',
              max_number_length: 20,
            },
          }),
        },
        {
          typeId: this.formFieldType.date,
          name: 'dueDate',
          label: this.locale.bankruptDueRights.dueDate,
          columnSize: 6,
          properties: JSON.stringify({
            validations: { required: true },
            dateConfig: { acceptFutureDate: true },
          }),
        },
        {
          typeId: this.formFieldType.text,
          name: 'debtOrigin',
          label: this.locale.bankruptDueRights.debtOrigin,
          columnSize: 6,
          properties: JSON.stringify({ validations: { required: true } }),
        },
        {
          typeId: this.formFieldType.selectbox,
          name: 'countryId',
          label: this.locale.bankruptDueRights.countryId,
          columnSize: 3,
          properties: JSON.stringify({
            validations: { required: true },
            dataSource: this.countries,
            hasExternalEffect: true,
          }),
        },
        {
          typeId: this.formFieldType.selectbox,
          name: 'cityId',
          label: this.locale.bankruptDebts.cityId,
          columnSize: 3,
          properties: JSON.stringify({
            validations: { required: true },
            textName: 'cityName',
            if: (!!(this.cities || []).length).toString(),
            dataSource: this.cities,
          }),
        },
        {
          typeId: this.formFieldType.text,
          name: 'cityName',
          label: this.locale.bankruptDebts.cityId,
          columnSize: 3,
          properties: JSON.stringify({
            validations: { required: true },
            if: (!(this.cities || []).length).toString(),
          }),
        },
        {
          typeId: this.formFieldType.radioButton,
          name: 'isGuaranteed',
          label: this.locale.bankruptDueRights.isGuaranteed,
          columnSize: 4,
          properties: JSON.stringify({
            dataSource: this.yesNoOptions,
            initialValue: false,
            hasExternalEffect: true,
          }),
        },
        {
          typeId: this.formFieldType.text,
          name: 'guaranteeType',
          label: this.locale.bankruptDueRights.guaranteeType,
          columnSize: 8,
          properties: JSON.stringify({
            validations: { conditionalRequired: 'obj.isGuaranteed == true' },
            disabledIf: 'obj.isGuaranteed != true',
          }),
        },
      ];
    },
  },
  created() {
    this.getCountries();
  },
  watch: {
    'formModel.countryId'(newValue) {
      this.getCountryCities(newValue);
    },
  },
  methods: {
    ...mapActions(['getCountries', 'getCountryCities']),
    externalEffectEventHandler({ name, value }) {
      if (name === 'isGuaranteed' && value === false) {
        this.$set(this.formModel, 'guaranteeType', null);
      }

      if (name === 'countryId') {
        if (value)
          this.getCountryCities(value);
        this.$set(this.formModel, 'cityName', null);
        this.$set(this.formModel, 'cityId', null);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
